module.exports = __webpack_public_path__ + "static/media/eGSlogo-Eagle Head_rev.795d275f.png";